// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n.modal-body {\r\n  padding: 15px;\r\n  width: 100%;\r\n}", ""]);
// Exports
module.exports = exports;
